// AI-ASSISTED: generated with claude-code on 2026-08-26, reviewed by <dev>
//
// Maintenance Windows (spec 003) — GrowthBook-gated (`backstage-maintenance-view`)
// area for maintenance-mode-service schedules + the application registry.
// Mounts pages via PageBlueprint (mirrors modules/releases/index.tsx).
//
// `/maintenance` (Foundational phase, T013), `/maintenance/applications`
// (US5, T044), and `/maintenance/schedules/:app` (US4, T039) are all
// registered here.
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const maintenancePageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'maintenance-schedules',
      params: {
        path: '/maintenance',
        loader: async () => {
          const { SchedulesPage } = await import('./SchedulesPage');
          return <SchedulesPage />;
        },
      },
    }),
    PageBlueprint.make({
      name: 'maintenance-applications',
      params: {
        path: '/maintenance/applications',
        loader: async () => {
          const { ApplicationsPage } = await import('./ApplicationsPage');
          return <ApplicationsPage />;
        },
      },
    }),
    PageBlueprint.make({
      name: 'maintenance-application-history',
      params: {
        path: '/maintenance/schedules/:app',
        loader: async () => {
          const { ApplicationHistoryPage } = await import('./ApplicationHistoryPage');
          return <ApplicationHistoryPage />;
        },
      },
    }),
  ],
});
